const THIN_SPACE = " "

function formatNumberWithThousandsSeparator(value) {
    if (value === null || value === undefined || value === "" || isNaN(value)) {
        return value
    }
    const [integerPart, decimalPart] = String(value).split(".")
    const isNegative = integerPart.startsWith("-")
    const digits = isNegative ? integerPart.slice(1) : integerPart
    const spacedIntegerPart = digits.replace(/\B(?=(\d{3})+(?!\d))/g, THIN_SPACE)
    return (isNegative ? "-" : "") + spacedIntegerPart + (decimalPart !== undefined ? "." + decimalPart : "")
}

exports.formatNumberWithThousandsSeparator = formatNumberWithThousandsSeparator
